import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CompanyRow } from '@shared/interface/company';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private readonly apiService = inject(ApiService);

  getCompany(): Observable<CompanyRow> {
    return this.apiService.get<any>('company').pipe(
      map((response) => response ?? null),
      catchError((error: any) => {
        console.error('Error fetching company:', error);
        return of(null as any);
      }),
    );
  }

  upsertCompany(company: Partial<CompanyRow>): Observable<CompanyRow> {
    return this.apiService.post<any>('company', company, true).pipe(map((response) => response));
  }
}
